export default __webpack_public_path__ + "static/media/Victoria-Lang.c62fe31c.jpg";